<template>
  <div class="section-header" :class="align">
    <span v-if="badge" class="badge">{{ badge }}</span>
    <h2 v-if="title">{{ title }}</h2>
    <p v-if="subtitle">{{ subtitle }}</p>
    <div v-if="showRedLine" class="red-line"></div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    badge: String,
    title: String,
    subtitle: String,
    align: { type: String, default: 'center' },
    showRedLine: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.section-header { text-align: var(--align, center); margin-bottom: 5rem; }
.section-header.left { text-align: left; }
.badge { color: var(--primary-red); font-weight: 800; letter-spacing: 2px; font-size: 14px; display: block; margin-bottom: 1rem; }
.section-header h2 { font-size: 42px; font-weight: 900; color: var(--primary-blue); margin-bottom: 1.5rem; }
.red-line { width: 60px; height: 4px; background: var(--primary-red); margin: 30px auto; }
.section-header.left .red-line { margin: 30px 0; }
</style>